import HealthClaimPage from './HealthClaimPage'

export default HealthClaimPage
